import { Action, action, State } from 'easy-peasy';

export interface InteractionsState {
  play: Action<InteractionsState>;
  pause: Action<InteractionsState>;
}

const initialState: State<InteractionsState> = {
  error: null,
};

export const interactionsState: InteractionsState = {
  /*================
   * State      
   ================*/
  ...initialState,

  /*================
   * Actions      
   ================*/

  play: action(() => {}),

  pause: action(() => {}),
};
